import { useTranslation } from "react-i18next";
import Breadcrumbs from "../components/Breadcrumbs";
import AvailableTimeSlotsCard from "../components/events/AvailableTimeSlotsCard";
import RecentlyCompletedSessionCard from "../components/recently-completed-session-card/RecentlyCompletedSessionCard";
import UpcomingSessionsCard from "../components/upcoming-session-card/UpcomingSessionsCard";
import LeftMenu from "../components/LeftMenu";
import { useAppSelector } from "../app/hooks";
import { selectUserProfile } from "../features/authentication/authenticationSlice";

const HomePage = () => {
  const { t } = useTranslation();
  const userProfile = useAppSelector(selectUserProfile);
  const firstName = userProfile?.name?.split(" ")[0] || "";

  return (
    <div className="flex h-full gap-4">
      {/* Left Side */}
      <LeftMenu />
      <div className="w-full p-4 pb-10 lg:px-10">
        <div className="lg:max-w-[694px]">
          <Breadcrumbs />
          <div className="space-y-4 py-6 lg:space-y-6">
            <h1>{t("home.welcomeBack", { firstName })}</h1>
            <UpcomingSessionsCard />
            <RecentlyCompletedSessionCard />
            <AvailableTimeSlotsCard />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
